import React from 'react';

function CustomBadge({ type }) {
    return <span className="ProductnotifyBadge">{type}</span>;
}

export default CustomBadge;
